import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLanguage } from '@components/common/locale/useLanguage';
function Breadcrumb(_ref) {
  var {
    pageInfo: {
      breadcrumbs
    }
  } = _ref;
  var [shouldShow, setShouldShow] = useState(false);
  var [isCart, setIsCart] = useState(false);
  var {
    isAr
  } = useLanguage();

  // Use a stable key derived from both the breadcrumb count AND their titles so that
  // a language switch (which changes titles but not length) correctly re-triggers this effect.
  var breadcrumbKey = breadcrumbs.map(b => b.title).join('|');
  useEffect(() => {
    var path = window.location.pathname;
    setShouldShow(breadcrumbs.length && path !== '/' && path !== '/checkout' && !path.startsWith('/search'));
    setIsCart(path === '/cart' || path.includes('/checkout/success/'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbKey]);
  return shouldShow ? /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1200px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb px-[2.6rem] ".concat(isAr ? 'pr-[22px] lg:pr-[55px]' : 'pl-[22px] lg:pl-[55px]', "  w-full flex items-center gap-8 my-8 md:mt-[5rem] ").concat(isCart ? 'mt-[11.75rem]' : 'mt-[2.75rem]', " uppercase")
  }, breadcrumbs.map((breadcrumb, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, index === breadcrumbs.length - 1 ? /*#__PURE__*/React.createElement("span", {
    className: "text-[#060708] font-bold md:text-[1.8rem] text-[1.4rem]  font-zoom-pro-compact rtl:mt-3 rtl:md:mt-0"
  }, breadcrumb.title) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: breadcrumb.url,
    className: "text-[#060708] md:text-[1.8rem]  text-[1.4rem]    font-thin font-zoom-pro-compact hover:text-[#C60910] transition-colors "
  }, breadcrumb.title), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "14",
    viewBox: "0 0 17 14",
    fill: "none",
    className: "flex-shrink-0 rtl:rotate-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02634 13.3828C8.96321 13.3198 8.91312 13.2449 8.87895 13.1624C8.84478 13.08 8.82719 12.9916 8.82719 12.9024C8.82719 12.8132 8.84478 12.7248 8.87895 12.6424C8.91312 12.5599 8.96321 12.485 9.02634 12.422L13.9792 7.46997L0.679072 7.46997C0.498976 7.46997 0.326255 7.39843 0.198908 7.27108C0.0715615 7.14373 1.87632e-05 6.97101 1.87712e-05 6.79092C1.87792e-05 6.61082 0.0715615 6.4381 0.198908 6.31075C0.326256 6.18341 0.498976 6.11186 0.679072 6.11186L13.9792 6.11186L9.02634 1.15986C8.89893 1.03244 8.82734 0.859628 8.82734 0.679431C8.82734 0.499235 8.89893 0.326419 9.02634 0.199001C9.15376 0.0715824 9.32658 -3.08963e-07 9.50678 -3.02285e-07C9.68697 -2.95607e-07 9.85979 0.0715824 9.98721 0.199001L16.0987 6.31049C16.1618 6.37355 16.2119 6.44844 16.2461 6.53088C16.2803 6.61332 16.2979 6.70168 16.2979 6.79092C16.2979 6.88016 16.2803 6.96852 16.2461 7.05095C16.2119 7.13339 16.1618 7.20828 16.0987 7.27135L9.98721 13.3828C9.92414 13.446 9.84925 13.4961 9.76681 13.5302C9.68438 13.5644 9.59601 13.582 9.50678 13.582C9.41754 13.582 9.32917 13.5644 9.24674 13.5302C9.1643 13.4961 9.08941 13.446 9.02634 13.3828Z",
    fill: "#C60910"
  }))))))) : null;
}
Breadcrumb.propTypes = {
  pageInfo: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    }))
  }).isRequired
};
export var query = "\n  query query {\n    pageInfo {\n      breadcrumbs {\n        title\n        url\n      }\n    }\n  }\n";
;
export default Breadcrumb;